export type ActivityLogDateRange = [Date, Date];

export interface IFiltersData {
  dateRange: ActivityLogDateRange;
}

export class FiltersData implements IFiltersData {
  dateRange: ActivityLogDateRange;

  constructor() {
    const today = new Date();
    this.dateRange = [today, today];
  }
}
